<template>
  <header>
    <img class="chatbot-logo" :src="config.logo" alt="logo" />
    <div class="chatbot-title-block">
      <span class="chatbot-title" :style="{ color: config.titleColor }"
        >Assistente Virtual</span
      >
      <a
        v-if="config.url"
        :href="config.url"
        target="_blank"
        class="chatbot-subtitle"
        :style="{ color: config.descriptionColor }"
        >ver mais</a
      >
    </div>
  </header>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "ChatHeader",
  props: {},
  computed: mapState("settings", {
    config: state => state.config
  })
};
</script>

<style lang="scss" scoped>
header {
  display: flex;
  align-items: center;
  text-align: left;
  height: 70px;
  background-color: white;
  border-bottom: 1px solid #afafaf38;

  .chatbot-logo {
    max-height: 50px;
    max-width: 150px;
    margin-left: 10px;
  }
  .chatbot-title-block {
    flex-grow: 1;
    margin-left: 20px;

    .chatbot-title {
      font-size: 1.3rem;
      display: block;
    }
    .chatbot-subtitle {
      font-size: 0.9rem;
      display: block;
      text-decoration: none;
      color: #3453d0;
    }
  }
}
</style>
